import { Stack, Typography } from '@mui/material'
import { Button } from 'utoniq-ui'

import { Maybe, PersonalInfoFragment } from '@/clients/utoniq-core/schema'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type BankAccountCellProps = {
  bank?: Maybe<PersonalInfoFragment['bank']>
}

export const BankAccountCell: Cell<BankAccountCellProps> = ({ bank }) => {
  const { t } = useTranslation('personalInfoSettings')
  const { routerPages } = useRouter()

  return (
    <CellFrame sx={{ py: 6 }}>
      <Stack
        pb={4}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="subtitle1" color="text.secondary">
          {t('bankAccount', '振込先口座')}
        </Typography>
        <Button
          variant="outlined"
          size="small"
          href={routerPages.BankCreate}
          sx={{ color: 'primary.main', borderColor: 'primary.main' }}
        >
          {t('change', '変更する')}
        </Button>
      </Stack>

      <Stack>
        {bank ? (
          <>
            <Typography variant="body1">
              {t('bankDetail', { ...bank, accountType: t(bank.accountType) })}
            </Typography>
          </>
        ) : (
          <Typography variant="body1" color="text.secondary">
            {t('emptyBankDetailMessage', '振込先口座の登録はありません')}
          </Typography>
        )}
      </Stack>
    </CellFrame>
  )
}
